export default "__VITE_ASSET__Dqa26kjO__"